// import "./update.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import Select from "react-select";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { centerInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify"; // Import Toastify
// import "react-toastify/dist/ReactToastify.css"; // Import styles
// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const CenterUpdate = ({ title }) => {
//   // Extracting centerId using regular expressions
//   const location = useLocation();
//   const centerId = location.pathname.match(/\/update-center\/(\d+)/)?.[1];

//   // Initializing state
//   const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   let [token] = useState(localStorage.getItem("token"));
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCenter = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/center/${centerId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         setInputValues(data.data);
//         setSelectedStatus(
//           statusOptions.find((opt) => opt.value == data.data.status)
//         );
//         setFile(data.data.logo_url);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (centerId) {
//       fetchCenter();
//     }
//   }, [centerId]);
//   console.log("quiz in a state:", file);

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };
//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };
//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();

//     formData.append("name", inputValues.name);
//     formData.append("address", inputValues.address);
//     formData.append("phone_no", inputValues.phone_no);
//     formData.append("status", parseInt(inputValues.status));

//     // Convert the existing image URL to a Blob and append if no new file is selected
//     if (file instanceof File) {
//       formData.append("logo", file); // Send new file
//     } else if (typeof file === "string") {
//       try {
//         const response = await fetch(file); // Fetch the existing image as a Blob
//         const blob = await response.blob();
//         const existingFile = new File([blob], "existing_logo.jpg", {
//           type: blob.type,
//         });
//         formData.append("logo", existingFile); // Append existing image in binary format
//       } catch (error) {
//         console.error("Error fetching existing logo:", error);
//       }
//     }

//     fetch(`${serverUrl}/upd_center/${centerId}`, {
//       method: "PUT",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log(data.code);
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             // Loop through the errors and show each in a toast
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "An error occurred, please try again.");
//           }
//         } else {
//           // If the response code is less than 400, show a success notification
//           toast.success(data.message || "Center updated successfully!");

//           // Delay for 5 seconds before navigating
//           setTimeout(() => {
//             navigate(`/center`);
//           }, 5000); // 5000 milliseconds = 5 seconds
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         toast.error("Failed to update the center. Please try again.");
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="left">
//                 <img
//                   src={
//                     file instanceof File
//                       ? URL.createObjectURL(file)
//                       : file || "/images/upload_file.png"
//                   }
//                   alt="preview"
//                   className="itemImg"
//                 />
//               </div>

//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       accept="image/*"
//                       onChange={(e) => {
//                         const selectedFile = e.target.files[0];

//                         if (
//                           selectedFile &&
//                           !selectedFile.type.startsWith("image/")
//                         ) {
//                           toast.error(
//                             "Only image files are allowed (e.g., JPG, PNG)."
//                           );
//                           e.target.value = ""; // Reset the input

//                           return;
//                         }

//                         setFile(selectedFile);
//                       }}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {centerInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/categories/${centerId}`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/center`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer />
//     </>
//   );
// };

// export default CenterUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { centerInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const CenterUpdate = ({ title }) => {
  const location = useLocation();
  const centerId = location.pathname.match(/\/update-center\/(\d+)/)?.[1];
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchCenter = async () => {
      try {
        const response = await fetch(`${serverUrl}/center/${centerId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch center data");
        }
        const data = await response.json();
        setInputValues(data.data);
        setSelectedStatus(
          statusOptions.find((opt) => opt.value == data.data.status)
        );
        setFile(data.data.logo_url);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch center data.");
      }
    };

    if (centerId) {
      fetchCenter();
    }
  }, [centerId]);

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && !selectedFile.type.startsWith("image/")) {
      toast.error("Only image files are allowed (e.g., JPG, PNG).");
      e.target.value = "";
      return;
    }
    setFile(selectedFile);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("name", inputValues.name);
    formData.append("address", inputValues.address);
    formData.append("phone_no", inputValues.phone_no);
    formData.append("status", parseInt(inputValues.status));

    if (file instanceof File) {
      formData.append("logo", file);
    } else if (typeof file === "string") {
      try {
        const response = await fetch(file);
        const blob = await response.blob();
        const existingFile = new File([blob], "existing_logo.jpg", {
          type: blob.type,
        });
        formData.append("logo", existingFile);
      } catch (error) {
        console.error("Error fetching existing logo:", error);
      }
    }

    try {
      const response = await fetch(`${serverUrl}/upd_center/${centerId}`, {
        method: "PUT",
        body: formData,
      });
      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Center updated successfully!");
        setTimeout(() => {
          navigate("/center");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="formGridItem">
                        <div className="formInput" style={{ textAlign: 'center' }}>
                          <img
                            src={
                              file instanceof File
                                ? URL.createObjectURL(file)
                                : file || "/images/upload_file.png"
                            }
                            alt="preview"
                            style={{ 
                              maxWidth: '200px', 
                              maxHeight: '200px', 
                              borderRadius: '8px',
                              marginBottom: '16px'
                            }}
                          />
                          <label htmlFor="file" style={{ cursor: 'pointer' }}>
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={<DriveFolderUploadOutlinedIcon />}
                            >
                              Upload Image
                            </Button>
                          </label>
                          <input
                            type="file"
                            id="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                          />
                        </div>
                      </Grid>
                      {centerInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/center")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Center
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default CenterUpdate;